import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UniqueEntityID } from '@digibricks/core';
import { SpeakingAnswerValue } from '../answer-value/speaking-answer-value';
import { Answer } from './answer';
export var SpeakingAnswer = /*#__PURE__*/function (_Answer) {
  _inherits(SpeakingAnswer, _Answer);

  var _super = _createSuper(SpeakingAnswer);

  function SpeakingAnswer() {
    _classCallCheck(this, SpeakingAnswer);

    return _super.apply(this, arguments);
  }

  _createClass(SpeakingAnswer, [{
    key: "value",
    get: function get() {
      return this.props.value;
    }
  }, {
    key: "attemptCount",
    get: function get() {
      var _this$props$attemptCo;

      return (_this$props$attemptCo = this.props.attemptCount) !== null && _this$props$attemptCo !== void 0 ? _this$props$attemptCo : 0;
    }
  }, {
    key: "retryCount",
    get: function get() {
      return this.attemptCount;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      var _this$value;

      return !((_this$value = this.value) !== null && _this$value !== void 0 && _this$value.audioFile);
    }
  }], [{
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var _ref, _data$attemptCount;

        var basePropsOrError = this.createFromJsonBaseProps(data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var speakingValue = undefined;

        if (data.value && data.value.audioFile) {
          var _data$value$responseT;

          var valueOrError = SpeakingAnswerValue.create({
            audioFile: data.value.audioFile,
            responseTime: (_data$value$responseT = data.value.responseTime) !== null && _data$value$responseT !== void 0 ? _data$value$responseT : 0
          });

          if (valueOrError.isFailure) {
            return Result.fail(valueOrError.error);
          }

          speakingValue = valueOrError.getValue();
        }

        var props = _objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          value: speakingValue,
          attemptCount: (_ref = (_data$attemptCount = data.attemptCount) !== null && _data$attemptCount !== void 0 ? _data$attemptCount : data.retryCount) !== null && _ref !== void 0 ? _ref : 0
        });

        return Result.ok(new SpeakingAnswer(props, new UniqueEntityID(props.id)));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return SpeakingAnswer;
}(Answer);